import { useMemo, useState } from 'react';
import SemesterRow from '../components/SemesterRow';
import ValidationAlert from '../components/ValidationAlert';
import FormulaModal from '../components/FormulaModal';
import ShareButton from '../components/ShareButton';
import StickyResultBar from '../components/StickyResultBar';
// import AdSlotPlaceholder from '../components/AdSlotPlaceholder';
import SEO from '../components/SEO';
import { calculateCgpa } from '../utils/cgpa';
import { ROUTE_META } from '../data/routeMeta';

function createSemester() {
  return { gpa: '8.00', credits: '20' };
}

export default function CgpaCalculatorPage() {
  const [semesters, setSemesters] = useState([createSemester(), createSemester()]);
  const meta = ROUTE_META['/cgpa-calculator'];

  const computed = useMemo(() => {
    if (semesters.length === 0) {
      return { error: 'Add at least one semester to calculate CGPA.' };
    }
    return calculateCgpa(semesters);
  }, [semesters]);

  const error = computed.error || '';
  const result = computed.error ? null : computed;

  function updateSemester(index, field, value) {
    setSemesters((prev) => prev.map((semester, i) => (i === index ? { ...semester, [field]: value } : semester)));
  }

  return (
    <>
      <SEO title={meta.title} description={meta.description} keywords={meta.keywords} canonicalPath="/cgpa-calculator" />
      <section className="space-y-4 pb-6">
        <div className="flex items-center justify-between">
          <h1 className="text-2xl font-bold">VIT CGPA Calculator</h1>
          <FormulaModal
            title="CGPA Formula"
            formula="CGPA = Sum(Semester GPA x Semester Credits) / Sum(Semester Credits)"
          />
        </div>

        <div className="grid grid-cols-12 gap-2 border-b border-brand-border pb-2 text-center text-xs font-semibold uppercase tracking-wide text-brand-muted">
          <p className="col-span-4">Semester</p>
          <p className="col-span-3">GPA</p>
          <p className="col-span-4">Credits</p>
          <p className="col-span-1 text-right"> </p>
        </div>

        <div className="space-y-0">
          {semesters.map((semester, index) => (
            <SemesterRow
              key={index}
              semester={semester}
              index={index}
              onChange={updateSemester}
              onRemove={(idx) => setSemesters((prev) => prev.filter((_, i) => i !== idx))}
              disableRemove={semesters.length <= 1}
            />
          ))}
        </div>

        <button
          type="button"
          onClick={() => setSemesters((prev) => [...prev, createSemester()])}
          className="w-full rounded-xl border border-dashed border-brand-border py-2 text-sm font-medium text-brand-muted hover:border-brand-accent hover:text-brand-accent"
        >
          + Add another semester
        </button>

        {/* <AdSlotPlaceholder label="Advertisement" className="xl:hidden rounded-2xl" /> */}
        <ValidationAlert message={error} />
      </section>

      <StickyResultBar
        label="Cumulative CGPA"
        value={result ? result.value.toFixed(2) : ''}
        helper={result ? `${result.totalCredits.toFixed(1)} total credits` : ''}
        action={result ? <ShareButton textToCopy={`GradeVIT CGPA Result: CGPA ${result.value.toFixed(2)} across ${result.totalCredits.toFixed(1)} credits.`} /> : null}
      />
    </>
  );
}
